var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 305,
    viewBox: "0 0 291 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.75 140.809V152.501C266.735 179.905 258.269 206.571 242.613 228.52C226.958 250.469 204.952 266.526 179.879 274.296C154.805 282.066 128.007 281.133 103.48 271.636C78.9541 262.139 58.0139 244.587 43.7829 221.597C29.5519 198.607 22.7925 171.412 24.5128 144.066C26.2332 116.721 36.3411 90.6916 53.3291 69.8594C70.3172 49.0273 93.275 34.5088 118.779 28.4693C144.283 22.4299 170.966 25.193 194.849 36.3466",
    stroke: "#0CC482",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.75 50.833L145.5 178.043L109.125 139.918",
    stroke: "#0CC482",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.5de52292ea73e12d54049462101f4288.svg";
export { ForwardRef as ReactComponent };